import React from 'react'
import Wrapper from 'components/wrappers/Wrapper'
import FormCheckbox from 'components/forms/bases/FormCheckbox'
import FormSwitch from 'components/forms/bases/FormSwitch'
import FormSelect from 'components/forms/bases/FormSelect'
import { updateObject } from 'helpers/objectHelpers'

const FormCarouselSettings = ({
  value,
  value: {
    autoplay = false,
    arrows = false,
    slidesToShow = 1,
    dots = false,
    infinite = false,
  },
  onChange,
}) => {
  const handleUpdate = (val, key) => {
    return onChange(updateObject(value, {[key]: val}))
  }
  return (
    <Wrapper.VerticalSeparator
      spacingTop
      elements={[
        <FormCheckbox
          label="Auto play"
          value={autoplay}
          onChange={(val) => handleUpdate(val, 'autoplay')}
        />,
        <FormCheckbox
          label="Infinite Play"
          value={infinite}
          onChange={(val) => handleUpdate(val, 'infinite')}
        />,
        <FormCheckbox
          label="Show Arrows"
          value={arrows}
          onChange={(val) => handleUpdate(val, 'arrows')}
        />,
        <FormCheckbox
          label="Show Dots for multiple slides"
          value={dots}
          onChange={(val) => handleUpdate(val, 'dots')}
        />,
        <FormSelect
          label="Amount of items to show"
          value={slidesToShow}
          options={[1, 2, 3, 4, 5, 6]}
          onChange={(val) => handleUpdate(val, 'slidesToShow')}
        />,
      ]}
    />
  )
}

FormCarouselSettings.propTypes = {}
FormCarouselSettings.defaultProps = {}

export default FormCarouselSettings



// WEBPACK FOOTER //
// ./src/components/forms/image/FormCarouselSettings.js